<template>
  <div class="main">
    <div class="logo">
      <!-- <img src="../assets/logo.png" alt="" /> -->
    </div>
    <div class="form">
      <img src="../assets/loginBg.png" alt="" />
      <!-- 表单 -->
      <div class="formData">
        <h3>忘记密码</h3>
        <el-form
          :model="ruleForm"
          :rules="rules"
          ref="ruleForm"
          label-width="100px"
          class="demo-ruleForm"
        >
          <el-form-item label="手机号" prop="phone">
            <el-input v-model="ruleForm.phone"></el-input>
          </el-form-item>
          <el-form-item label="验证码" prop="code">
            <el-input style="width: 185px" v-model="ruleForm.code"></el-input>
            <!-- <div >获取验证码</div> -->
            <el-button
              :disabled="counting"
              class="getcode"
              @click="getcode"
              type="primary"
              >{{ buttonText }}</el-button
            >
          </el-form-item>
          <el-form-item label="密码" prop="pass">
            <el-input
              type="password"
              v-model="ruleForm.pass"
              autocomplete="off"
            ></el-input>
          </el-form-item>
          <el-form-item label="重复密码" prop="checkPass">
            <el-input
              type="password"
              v-model="ruleForm.checkPass"
              autocomplete="off"
            ></el-input>
          </el-form-item>
          <el-form-item>
            <el-button
              style="width: 100%; border-radius: 30px; margin-top: 10px"
              type="primary"
              @click="submitForm('ruleForm')"
              >保存</el-button
            >
          </el-form-item>
          <div class="tip">
            <span class="tologin">已有账号?</span>
            <router-link :to="{ path: '/login' }"
              ><span>马上登录</span></router-link
            >
          </div>
        </el-form>
      </div>
    </div>
    <div class="company">
      <p>河北睿银金融服务外包有限公司</p>
      <p>版权所有 @ 河北睿银金融服务外包有限公司.冀ICP备18005534号-1</p>
    </div>
  </div>
</template>
  
  <script>
export default {
  data() {
    var validatePass2 = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请再次输入密码"));
      } else if (value !== this.ruleForm.pass) {
        callback(new Error("两次输入密码不一致!"));
      } else {
        callback();
      }
    };
    var validatorPhone = function (rule, value, callback) {
      if (value === "") {
        callback(new Error("手机号不能为空"));
      } else if (!/^1\d{10}$/.test(value)) {
        callback(new Error("手机号格式错误"));
      } else {
        callback();
      }
    };
    return {
      ruleForm: {
        phone: "",
        pass: "",
        code: "",
        checkPass: "",
      },
      rules: {
        code: [{ required: true, message: "请输入验证码", trigger: "blur" }],
        pass: [{ required: true, message: "请输入密码", trigger: "blur" }],
        phone: [{ required: true, validator: validatorPhone, trigger: "blur" }],
        checkPass: [
          { required: true, validator: validatePass2, trigger: "blur" },
        ],
      },
      counting: false, // 控制倒计时状态
      countdownSeconds: 60, // 初始化倒计时为60秒
      buttonText: "获取验证码", // 默认按钮文本
    };
  },
  methods: {
    //获取验证码
    getcode() {
      var regExp = /^1[3456789]\d{9}$/;
      if (!regExp.test(this.ruleForm.phone)) {
        this.$message({
          message: "手机号格式错误",
          type: "error",
        });
        return;
      }
      if (this.counting) {
        return; // 如果正在进行倒计时则不再重复点击
      }
      this.$message({
        message: "发送成功！",
        type: "success",
      });
      this.counting = true; // 开始倒计时
      let timerId = setInterval(() => {
        if (this.countdownSeconds > 1) {
          this.countdownSeconds--; // 每次减少1秒
          this.buttonText = `${this.countdownSeconds}秒`; // 更新按钮文本
        } else {
          clearInterval(timerId); // 清除定时器
          this.resetButton(); // 重置按钮状态
        }
      }, 1000);
    },
    resetButton() {
      this.counting = false; // 结束倒计时
      this.countdownSeconds = 60; // 重置倒计时为60秒
      this.buttonText = "获取验证码"; // 还原按钮文本
    },
    // 提交表单
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.$message({
            message: "注册成功！",
            type: "success",
          });
          setTimeout(() => {
            this.$router.push({
              path: "/login",
            });
          }, 1000);
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
  },
};
</script>
  
  <style lang="less" scoped>
.main {
  padding-bottom: 50px;
  background: #f2f6fc;
  .logo {
    height: 100px;
    // padding: 20px 0 20px 50px;
    // img {
    //   width: 160px;
    //   height: 60px;
    // }
  }
  .form {
    display: flex;
    width: 900px;
    margin: 0 auto;
    img {
      width: 450px;
      height: 500px;
    }
    .formData {
      flex: 1;
      background: #ffffff;
      h3 {
        padding-top: 20px;
        text-align: center;
        font-size: 30px;
        color: #515a6e;
      }

      .el-form {
        padding-right: 50px;
        .getcode {
          float: right;
          width: 110px;
        }
      }
      .tip {
        text-align: center;
        a {
          text-decoration: none;
        }
        .router-link-active {
          text-decoration: none;
        }
        span {
          font-size: 14px;
          color: #2d8cf0;
        }
        .tologin {
          color: #515a6e;
          padding-left: 100px;
          padding-right: 10px;
        }
      }
    }
  }
  .company {
    margin-top: 30px;
    text-align: center;
    font-size: 14px;
    color: #515a6e;
  }
}
</style>